import { ExpectedSubscriptionOfPlanification } from '@sdk/contracts';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { useProfile } from '../profile';

import { sdk } from '@/services';

const PlanificationService = sdk.getService('PlanificationService');

export const useExpectedSubscriptionsOfPlanification = () => {
  const { profile } = useProfile();
  const userId = profile?._id;

  const { data, isPending } = useQuery({
    queryKey: ['planification', 'expected-subscriptions-of-planification', userId],
    queryFn: () => PlanificationService.getExpectedSubscriptionsOfPlanification(userId!),
    enabled: !!userId
  });

  const { onTimeSubscriptions, bitLateSubscriptions, lateSubscriptions } = useMemo(() => {
    const initial = {
      onTimeSubscriptions: [] as ExpectedSubscriptionOfPlanification[],
      bitLateSubscriptions: [] as ExpectedSubscriptionOfPlanification[],
      lateSubscriptions: [] as ExpectedSubscriptionOfPlanification[]
    };

    if (!data) return initial;

    return data.expectedSubscriptionsOfPlanification.reduce((acc, subscription) => {
      const diff = subscription.expectedProgress - subscription.actualProgress;
      if (diff <= 0) {
        acc.onTimeSubscriptions.push(subscription);
      } else if (diff <= 10) {
        acc.bitLateSubscriptions.push(subscription);
      } else {
        acc.lateSubscriptions.push(subscription);
      }
      return acc;
    }, initial);
  }, [data]);

  return {
    expectedSubscriptionsOfPlanificationForToday: data,
    onTimeSubscriptions,
    bitLateSubscriptions,
    lateSubscriptions,
    isPending
  };
};
